import {accountIs} from './siteUtils';

export const accountIsDemo = () => {
	return accountIs('localhost', true);
};
export const accountIsAssal = (orDemo = false) => {
	return accountIs('alassalsweets', orDemo);
};
